/* eslint-disable consistent-return, array-callback-return */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { isDefined } from 'utils/validation';
import { isEmbeddedInWebView } from 'utils/webview';

import EventMonitor from 'components/EventMonitor/EventMonitor';

import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';

import styles from './SiteFooterMinimal.scss';

const SiteFooterMinimal = memo(({ data }) => {
  const inWebView = isEmbeddedInWebView();

  return data ? (
    <footer className={`${styles.footer} container-fluid`}>
      <div className={styles.links}>
        {isDefined(data.site.links) &&
          data.site.links.map((link, index) => {
            if (index < 3) {
              const eventProps = {
                actionType: 'redirect',
                originComponent: 'footer minimal link',
                shortDescription: `footer minimal link: site links: ${link.title}`,
              };

              return (
                // eslint-disable-next-line react/no-array-index-key
                <EventMonitor key={`footer-minimal-site-links-${index}`} {...eventProps}>
                  <a
                    href={link.href}
                    target={link.popup || inWebView ? '_blank' : '_self'}
                    rel="noreferrer"
                  >
                    <Typography element="span" styleAs="paragraphSmallLight" textStyle="body-s">
                      {link.title}
                    </Typography>
                  </a>
                </EventMonitor>
              );
            }
          })}
      </div>
      <div className={styles.copyright}>
        <Typography element="span" styleAs="paragraphSmallLight" textStyle="body-s">
          {data.copyright}
        </Typography>
      </div>
    </footer>
  ) : null;
});

SiteFooterMinimal.propTypes = {
  data: PropTypes.object,
};

SiteFooterMinimal.displayName = 'SiteFooterMinimal';

export default SiteFooterMinimal;
